import styled from 'styled-components';
import { durations, curves } from '@cbhq/cds-common/motion/tokens';
import { spacing, palette } from '@cbhq/cds-web/tokens';
import '../../ui/Div/index.js';
import { jsx } from 'react/jsx-runtime';
import { Div } from '../../ui/Div/Div.js';
const TOGGLE_WIDTH = '18px';
const TOGGLE_HEIGHT = '17px';
function BurgerButton({
  isOpen
}) {
  return /*#__PURE__*/jsx(Div, {
    position: "relative",
    width: TOGGLE_WIDTH,
    height: TOGGLE_HEIGHT,
    css: {
      cursor: 'pointer'
    },
    children: /*#__PURE__*/jsx(Toggle, {
      isOpen: isOpen,
      closeState: !isOpen
    })
  });
}
const Toggle = styled.div.withConfig({
  shouldForwardProp: p => !['closeState'].includes(p)
})`
  top: ${spacing[1]};
  transform: ${({
  closeState
}) => !closeState ? 'rotate(45deg)' : 'initial'};

  &,
  &:before,
  &:after {
    content: '';
    position: absolute;
    width: 100%;
    height: 2px;
    background-color: ${palette.foreground};
    border-radius: ${spacing[0.5]};
    transition:
      ${durations.moderate3}ms transform,
      background-color cubic-bezier(${curves.global.join(',')});
  }

  &:before {
    transform: ${({
  closeState
}) => !closeState ? 'translateY(0)' : 'translateY(-8px)'};
  }

  &:after {
    transform: ${({
  closeState
}) => !closeState ? 'translateY(0) rotate(-90deg)' : 'translateY(8px) rotate(0)'};
  }
`;
export { BurgerButton };
//# sourceMappingURL=BurgerButton.js.map
